invHdApp.controller('DashboardAnalyticController', ['$scope', 'Analytic', 'Account', '$location', 'FileUploader', '$http',
	function ($scope, Analytic, Account, $location, FileUploader, $http) {

		$scope.filterProp = [];

		$scope.filterData = {
			export: false,
			customers: [],
			workers: [],
			workSteps: [],
			page: 1,
			date_type: 'cargo_date',
			scheduled_time: {
				startDate: moment().subtract(6, 'days').toDate(),
				endDate: moment().toDate()
			},
		}

		$scope.$on('refresh_data', function () {
			console.log('refreshing order reports...')
			$scope.init();
		}, true);

		$scope.clearFilter = function (page) {
			$scope.filterData = {
				export: false,
				customers: [],
				workers: [],
				workSteps: [],
				page: 1,
				date_type: 'cargo_date',
				scheduled_time: {
					startDate: moment().toDate(),
					endDate: moment().toDate()
				}
			}
		}

		$scope.options = {
			tooltips: {
				enabled: false
			},
			plugins: {
				datalabels: {
					formatter: (value, ctx) => {
						let sum = 0;
						let dataArr = ctx.chart.data.datasets[0].data;
						dataArr.map(data => {
							sum += data;
						});
						let percentage = (value * 100 / sum).toFixed(2) + "%";
						return percentage;
					},
					color: '#fff',
				}
			}
		}
		$scope.init = function (type) {
			Analytic.orderDashboard($scope.filterData).success(function (data, status, headers, config) {
				if (typeof type !== undefined && type == 'export') {
					$scope.filterData.export = false;
					window.location.href = data.url;
				} else {
					$scope.data = data;
					$scope.customerRate = {
						type: "pie",
						backgroundColor: 'none',
						plotarea: {
							backgroundColor: 'transparent'
						},
						plot: {
							backgroundColor: "#2B313B",
							borderColor: "#2B313B",
							borderWidth: 5,
							valueBox: {
								placement: 'out',
								text: '%t\n%npv%',
								fontFamily: "Open Sans"
							},
							tooltip: {
								fontSize: '18',
								fontFamily: "Open Sans",
								padding: "5 10",
								text: "%npv%"
							},
							animation: {
								effect: 2,
								method: 5,
								speed: 900,
								sequence: 1,
								delay: 3000
							},
						},
						title: {
							fontColor: "#8e99a9",
							text: 'Kargo Müşteri Oranı',
							align: "center",
							offsetX: 10,
							fontSize: 25
						},
						plotarea: {
							margin: "20 0 0 0"
						},
						series: data.customer_rate,
					};
					$scope.successRate = Number((100 - ((100 * data.count.fail) / data.count.total)).toFixed(2));
					if ($scope.successRate < 1) {
						$scope.successRate = 100;
					}
					$scope.gauge = {
						type: "gauge",
						backgroundColor: 'none',
						plotarea: {
							backgroundColor: 'transparent'
						},
						title: {
							fontColor: "#8e99a9",
							text: 'Lojimod Başarı Oranı',
							align: "center",
							offsetX: 0,
							fontSize: 25,
						},
						globals: {
							fontSize: 25
						},
						plotarea: {
							marginTop: 180
						},
						plot: {
							size: '100%',
							valueBox: {
								placement: 'center',
								text: '%v',
								fontSize: 35,
								rules: [{
									rule: '%v >= 90',
									text: '%v<br>Mükemmel'
								},
								{
									rule: '%v < 60 && %v > 90',
									text: '%v<br>İyi'
								},
								{
									rule: '%v < 20 && %v > 60',
									text: '%v<br>Kötü'
								},
								{
									rule: '%v <  0',
									text: '%v<br>Berbat'
								}
								]
							}
						},
						tooltip: {
							borderRadius: 5
						},
						scaleR: {
							aperture: 180,
							minValue: 0,
							maxValue: 100,
							step: 1,
							center: {
								visible: false
							},
							tick: {
								visible: true
							},
							item: {
								offsetR: 0,
								rules: [{
									rule: '%i == 9',
									offsetX: 15
								}]
							},
							labels: ['0', '', '', '', '', '', '20', '60', '90', '', '100'],
							ring: {
								size: 50,
								rules: [{
									rule: '%v <= 20',
									backgroundColor: '#E53935'
								},
								{
									rule: '%v > 20 && %v < 60',
									backgroundColor: '#EF8535'
								},
								{
									rule: '%v >= 60 && %v < 90',
									backgroundColor: '#29B6F6'
								},
								{
									rule: '%v >= 90',
									backgroundColor: '#7209b7'
								}
								]
							}
						},
						refresh: {
							type: "feed",
							transport: "js",
							url: "feed()",
							interval: 1500,
							resetTimeout: 1000
						},
						series: [{
							values: [$scope.successRate], // starting value
							backgroundColor: 'black',
							indicator: [10, 10, 10, 10, 0.75],
							animation: {
								effect: 2,
								method: 1,
								sequence: 4,
								speed: 900
							},
						}]
					}
					$scope.orderChart = {
						type: "bar",
						utc: true,
						backgroundColor: 'none',
						plotarea: {
							backgroundColor: 'transparent'
						},
						title: {
							fontColor: "#8e99a9",
							text: 'Günlük Kargo Sayısı (Son 14 gün)',
							align: "center",
							offsetX: 10,
							fontSize: 25,
							marginBottom: 30
						},
						"scale-y": {
							"line-color": "#f6f7f8",
							"shadow": 0,
							"guide": {
								"line-style": "dashed"
							},
							"label": {
								"text": "Kargo Sayısı",
							},
							"minor-ticks": 0,
							"thousands-separator": ","
						},
						"crosshair-x": {
							"line-color": "#efefef",
							"plot-label": {
								"border-radius": "5px",
								"border-width": "1px",
								"border-color": "#f6f7f8",
								"padding": "10px",
								"font-weight": "bold"
							},
							"scale-label": {
								"font-color": "#000",
								"background-color": "#f6f7f8",
								"border-radius": "5px"
							}
						},
						"tooltip": {
							"visible": false
						},
						"scaleX": {
							"values": data.chart.labels,

							"placement": "default",
							"tick": {
								"size": 58,
								"placement": "cross"
							},
							"itemsOverlap": true,
							"item": {
								"offsetY": -55
							}
						},
						"series": [{
							"values": data.chart.values,

							"text": "Kargo Sayısı",
							"line-color": "#007790",
							"legend-item": {
								"background-color": "#007790",
								"borderRadius": 5,
								"font-color": "white"
							},
							"legend-marker": {
								"visible": false
							},
							"marker": {
								"background-color": "#007790",
								"border-width": 1,
								"shadow": 0,
								"border-color": "#69dbf1"
							},
							"highlight-marker": {
								"size": 6,
								"background-color": "#007790",
							}
						}]
					}
				}
			});
		};

		$scope.getPage = function (page) {
			$scope.filterData.page = page;
			$scope.filter();
		}

		$scope.export = function (page) {
			$scope.filterData.export = true;
			$scope.init('export');
		}

		$scope.sort = function (field, sort) {
			$scope.filterData.field = field;
			$scope.filterData.sort = sort;
			$scope.filter();
		}

		$scope.filter = function (type) {
			if (type == 'clear') {
				$scope.filterData = {
					export: false,
					customers: [],
					workers: [],
					workSteps: [],
					page: 1,
					created_at: {
						startDate: null,
						endDate: null
					},
					scheduled_time: {
						startDate: null,
						endDate: null
					}
				}
			}
			$scope.init();
		}


	}
]);
